import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FilterCard from "./components/filterCard";
import AlertList from "./components/alertsList";

function AlertDashboard() {
  const [selectedDate, setSelectedDate] = useState("");

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <FilterCard onDateLoad={(date) => setSelectedDate(date)} />
      <AlertList selectedDate={selectedDate} />
    </DashboardLayout>
  );
}

export default AlertDashboard;